import type { BallColor } from './types';

export const BALL_VALUES: Record<BallColor, number> = {
  red: 1,
  yellow: 2,
  green: 3,
  brown: 4,
  blue: 5,
  pink: 6,
  black: 7,
};

export const COLORS_PHASE_ORDER: BallColor[] = [
  'yellow',
  'green',
  'brown',
  'blue',
  'pink',
  'black',
];

export const INITIAL_REDS = 15;
export const MIN_FOUL_VALUE = 4;
export const DEFAULT_UNDO_LIMIT = 6;
export const MAX_SCORE_POSSIBLE = 147;

export const PIN_MIN_LENGTH = 4;
export const PIN_MAX_LENGTH = 6;
export const LOGIN_MAX_ATTEMPTS = 3;
export const LOGIN_LOCKOUT_SECONDS = 60;

export const DEFAULT_SUPER_ADMIN_PIN = '0000';
export const DEFAULT_SUPER_ADMIN_NAME = 'Super Admin';
